import {
  Flex,
  Icon,
  InputGroup,
  InputProps,
  createRecipeContext,
} from '@chakra-ui/react';
import React, { FunctionComponent as FC } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';
import MCustomIconButton from '../../MCustomIconButton';

/**
 * Chakra's `Input` (the same `input` recipe) without its form field context.
 * The search box sits inside the select's field but isn't that field's
 * control: as an `Input` it took the field's id, duplicating the select's own
 * input, and its invalid state, so a field with an error painted the search
 * box red too.
 */
const { withContext } = createRecipeContext({ key: 'input' });
const SearchBoxInput = withContext<HTMLInputElement, InputProps>('input');

interface SearchInputProps {
  ref: any;
  count?: number;
  onKeyDown: any;
  value: string;
  onChange: (val: string) => void;
  children?: React.ReactNode;
}

const SearchInput: FC<SearchInputProps> = React.forwardRef<
  any,
  SearchInputProps
>(({ children, value, onChange, count = 0, onKeyDown, ...rest }, ref) => {
  const onSetEmpty = () => {
    onChange('');
  };

  // `InputGroup` pads the input past its start/end elements (v2's
  // `InputGroup` did the same); bare `InputElement`s would let the
  // placeholder run under the search icon.
  return (
    <Flex mx="2" mt={2}>
      <InputGroup
        startElement={
          <Icon asChild>
            <MdSearch />
          </Icon>
        }
        endElement={
          value && (
            <MCustomIconButton
              icon={MdClose}
              aria-label="Clear"
              bg="none"
              _focus={{
                bg: 'tBlue.hover',
              }}
              onClick={onSetEmpty}
              onKeyDown={(ev) => ev.stopPropagation()}
            />
          )
        }
      >
        <SearchBoxInput
          ref={ref}
          value={value}
          placeholder="Search..."
          onKeyDown={onKeyDown}
          onChange={(e: any) => onChange(e.target.value)}
        />
      </InputGroup>
    </Flex>
  );
});

export default SearchInput;
